import { c as _c } from "react-compiler-runtime";
import { useReducer, useCallback } from 'react';
import { MSG_TYPE_NOTIFICATION_SETTINGS_FAILURE, MSG_TYPE_NOTIFICATION_SETTINGS_LOADING, MSG_TYPE_NOTIFICATION_SETTINGS_SUCCESS, MSG_TYPE_OPEN_NOTIFICATION_SETTINGS_MODAL, MSG_TYPE_SAVE_NOTIFICATION_SETTINGS } from 'collaboration-sidebar/constants/IFrameMessageTypes';
import { GLOBAL_NOTIFICATION_EMAIL_SETTING } from '../../constants/notificationSettings';
const HANDLE_CLOSE = 'HANDLE_CLOSE';
const HANDLE_CONFIRM = 'HANDLE_CONFIRM';
function reducer(state, action) {
  switch (action.type) {
    case MSG_TYPE_OPEN_NOTIFICATION_SETTINGS_MODAL:
      return Object.assign({}, state, {
        show: true,
        userSetting: action.userSetting,
        globalSettings: action.globalSettings
      });
    case MSG_TYPE_NOTIFICATION_SETTINGS_FAILURE:
      return Object.assign({}, state, {
        failure: true,
        loading: false
      });
    case MSG_TYPE_NOTIFICATION_SETTINGS_LOADING:
      return Object.assign({}, state, {
        failure: false,
        loading: true
      });
    case MSG_TYPE_NOTIFICATION_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        failure: false,
        loading: false
      });
    case HANDLE_CONFIRM:
      return Object.assign({}, state, {
        show: false
      });
    case HANDLE_CLOSE:
      return Object.assign({}, state, {
        show: false
      });
    default:
      return state;
  }
}
export default function useNotificationSettingsModal(t0) {
  "use memo";

  const $ = _c(19);
  const {
    sendMessageRef,
    isSendMessageReady
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      show: false,
      failure: false,
      loading: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [t2, dispatch] = useReducer(reducer, t1);
  const {
    show,
    failure,
    loading,
    userSetting,
    globalSettings
  } = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = t4 => {
      const {
        payload
      } = t4;
      bb2: switch (payload.type) {
        case MSG_TYPE_OPEN_NOTIFICATION_SETTINGS_MODAL:
          {}
        case MSG_TYPE_NOTIFICATION_SETTINGS_FAILURE:
          {}
        case MSG_TYPE_NOTIFICATION_SETTINGS_LOADING:
          {}
        case MSG_TYPE_NOTIFICATION_SETTINGS_SUCCESS:
          {
            dispatch(payload);
            break bb2;
          }
        default:
          {
            dispatch(payload);
          }
      }
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleMessage = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => dispatch({
      type: HANDLE_CLOSE
    });
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const onClose = t4;
  let t5;
  if ($[3] !== isSendMessageReady || $[4] !== sendMessageRef || $[5] !== userSetting) {
    t5 = updatedSetting => {
      if (isSendMessageReady && sendMessageRef.current && updatedSetting !== userSetting) {
        sendMessageRef.current(MSG_TYPE_SAVE_NOTIFICATION_SETTINGS, {
          userSetting: updatedSetting
        });
      }
      dispatch({
        type: HANDLE_CONFIRM
      });
    };
    $[3] = isSendMessageReady;
    $[4] = sendMessageRef;
    $[5] = userSetting;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const onSave = t5;
  let t6;
  if ($[7] !== globalSettings) {
    t6 = globalSettings ? globalSettings.newComments.enabledChannels.includes(GLOBAL_NOTIFICATION_EMAIL_SETTING) : false;
    $[7] = globalSettings;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const newCommentsEnabled = t6;
  let t7;
  if ($[9] !== globalSettings) {
    t7 = globalSettings ? globalSettings.atMentions.enabledChannels.includes(GLOBAL_NOTIFICATION_EMAIL_SETTING) : false;
    $[9] = globalSettings;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const atMentionsEnabled = t7;
  let t8;
  if ($[11] !== atMentionsEnabled || $[12] !== failure || $[13] !== loading || $[14] !== newCommentsEnabled || $[15] !== onSave || $[16] !== show || $[17] !== userSetting) {
    t8 = {
      handleMessage,
      onClose,
      onSave,
      show,
      loading,
      failure,
      userSetting,
      newCommentsEnabled,
      atMentionsEnabled
    };
    $[11] = atMentionsEnabled;
    $[12] = failure;
    $[13] = loading;
    $[14] = newCommentsEnabled;
    $[15] = onSave;
    $[16] = show;
    $[17] = userSetting;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}